export { API_URL, MEMBERS_API_URL, WEEK_ONE_API_URL, IS_LOCAL } from './environment.config';